import React from 'react';

export const PinstripePattern = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="0" height="0">
      <defs>
        <pattern
          id="pinstripe"
          patternUnits="userSpaceOnUse"
          width="3"
          height="3"
          patternTransform="rotate(45)"
        >
          <line
            x1="0"
            y="0"
            x2="0"
            y2="5.5"
            stroke="#194d33"
            strokeWidth="1.5"
          />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#pinstripe)" opacity="1" />
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/common/svg/PinstripePattern.js